<template>
    <div class="pl-time" @click="!lv_disabled&&!lv_readonly && pl_click()">
        <slot :value="p_value">
            <link-input
                @click-suffix-icon="!lv_disabled&&!lv_readonly && pl_clear()"
                :required="required"
                :validate-on-init="validateOnInit"
                :rules="rules"

				input-readonly
                :suffix-icon="suffixIcon"
                :value="p_value"
                :type="type"
                :color="color"
                :size="size"
                :shape="shape"
                :dashed="dashed"
                :long="long"
                :prefixIcon="prefixIcon"
                :suffixIcon="suffixIcon"
                :placeholder="placeholder"
                :disabled="lv_disabled"
            />
        </slot>
        <link-popper
            ref="popper"
            slot="prepend"
            v-bind="popperBinding"
            :reference="!lv_mounted?null:$el"
            :onOpen="pl_open">
            <pl-time-panel :value="p_value" @input="pl_panelInput" :default-value="p_value" :max="max" :min="min" ref="panel" @clickLabel="p_clickLabel"/>
        </link-popper>
    </div>
</template>

<script>
    import PlTimePanel from "./pl-time-panel";
    import {EditMixin, MountedMixin, NewValueMixin,} from "../../mixins";

    export default {
        name: "pl-time",
        components: {PlTimePanel},
        mixins: [MountedMixin, NewValueMixin, EditMixin],
        props: {
            max: {type: String},                                                    //最大值
            min: {type: String},                                                    //最小值

            required: {type: Boolean},
            rules: {type: Array | String},
            validateOnInit: {type: Boolean,},

            type: {type: String, default: 'line',},
            color: {type: String, default: 'info',},
            size: {type: String, default: 'default',},
            shape: {type: String, default: 'none',},
            dashed: {type: Boolean,},
			defaultValue: {type: String, default: '08:00:00'},

            long: {type: Boolean,},
            prefixIcon: {type: String},
            suffixIcon: {type: String, default: 'link-icon-time-circle'},
            placeholder: {type: String, default:()=> LinkVue.$t('LinkForm.clickToInputContent')},
        },
        watch: {
            value(val) {
                this.p_value !== val && (this.p_value = val)
            },
        },
        computed: {
            popperBinding() {
                return {
                    height: 208,
                    width: 150,
                    disabledEqual: true,
                }
            },
        },
        methods: {
            pl_clear() {
                this.p_value = null
                this.p_emitValue()
            },
            async p_clickLabel(timeString) {
                await this.$lv.nextTick()
                this.$emit('confirm', timeString)
                this.$refs.popper.hide()
                this.pl_panelInput(timeString)
            },
            pl_click() {
                !!this.$refs.popper.p_show ?
                    this.$refs.popper.hide()
                    :
                    this.$refs.popper.show()
            },
            pl_panelInput(val) {
                this.p_value = val
                this.p_emitValue()
            },
            pl_open() {
                this.$nextTick(() => {
                    this.$refs.panel.update()
                })
            },
        },
    }
</script>

<style lang="scss">
    @include themeify {
        .pl-time {
            display: inline-block;
            vertical-align: middle;
			margin-top: -3px;
        }
        .pl-time-panel {
            @include public-style;
            display: inline-block;
            width: 100%;

            .pl-time-panel-label-wrapper {
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                z-index: 1;

                .pl-time-panel-label {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: white;
                    z-index: 2;
                    cursor: pointer;

                    span {
                        padding: 6px 12px;
                        border-radius: 4px;

                        &:hover {
                            background-color: pl-var(color-primary-light);
                        }
                    }
                }

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 1px;
                    z-index: 1;
                    box-shadow: 0 0 15px 1px #ddd;
                }
            }

            .pl-time-spin-wrapper {
                display: inline-flex;
                align-items: center;
                position: relative;
                z-index: 0;
            }
        }
    }
</style>
